module.exports = __webpack_public_path__ + "static/media/overview_2.e9ed93e6.png";